  import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
  import { SharedDateService } from '../../../../../../shared/services/shared-date.service';
  import { AuthService } from '../../../../../../shared/services/auth.service';
  import { MapService } from '../../../../../../shared/services/map.service';
import { SidebarService } from '../../../../../../shared/services/sidebar.service';
import { TranslateService } from '@ngx-translate/core';
import { GroupRole } from '../../../../../../shared/models/group-role';
import { GlobalVars } from '../../../../../../shared/global-vars';

  @Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
  })
  export class FooterComponent implements OnInit {

    months = [
      { name: 'MAP.MONTHS.JANUARY', value: 0 },
      { name: 'MAP.MONTHS.FEBRUARY', value: 1 },
      { name: 'MAP.MONTHS.MARCH', value: 2 },
      { name: 'MAP.MONTHS.APRIL', value: 3 },
      { name: 'MAP.MONTHS.MAY', value: 4 },
      { name: 'MAP.MONTHS.JUNE', value: 5 },
      { name: 'MAP.MONTHS.JULY', value: 6 },
      { name: 'MAP.MONTHS.AUGUST', value: 7 },
      { name: 'MAP.MONTHS.SEPTEMBER', value: 8 },
      { name: 'MAP.MONTHS.OCTOBER', value: 9 },
      { name: 'MAP.MONTHS.NOVEMBER', value: 10 },
      { name: 'MAP.MONTHS.DECEMBER', value: 11 }
    ];

    currentMonth: number = new Date().getMonth();
    currentYear: number = new Date().getFullYear();
    selectedMonth: { name: string, value: number, year: number };
    selectedDate: Date = new Date();
    exactSelectedDate: Date = new Date();
    today: Date = new Date();

    visibleMonths: { name: string, value: number, year: number }[] = [];
    minSelectableDate: Date = new Date(2022, 8);
    maxSelectableDate: Date = new Date(this.currentYear, this.currentMonth);
    currentZoomLevel: number = 0;
    isLoggedIn: boolean = false;
    userGroups: GroupRole[] = [];
    isPremium: boolean = false;
    isPrivileged: boolean = false;

    constructor(private cdRef: ChangeDetectorRef, private sharedDateService: SharedDateService, private authService: AuthService, private mapService: MapService, private sidebarService: SidebarService, private translate: TranslateService) {
      this.selectedMonth = {
        name: this.months[this.currentMonth].name,
        value: this.currentMonth,
        year: this.currentYear
      };
    }

    ngOnInit(): void {
      this.authService.getUserInfo().subscribe( res => {
        if(res?.groupeUtilisateur)
        this.userGroups = res?.groupeUtilisateur;
        if(this.userGroups)
        this.isPremium = this.userGroups.some(groupRole => groupRole.groupe.nom !== "Public");
      });

      this.sharedDateService.resetDate$.subscribe(res => {
        if(this.today.getMonth() < this.selectedDate.getMonth() || this.today.getFullYear() < this.selectedDate.getFullYear()){
          this.selectedMonth = {
            name: this.months[this.today.getMonth()].name,
            value: this.today.getMonth(),
            year: this.today.getFullYear()
          };
          this.onMonthSelect({ value: this.selectedMonth.value, year: this.selectedMonth.year });
        }
      })

      this.translate.onLangChange.subscribe(() => {
        const currentSelectedDate = this.selectedDate;
        this.selectedDate = new Date();
        setTimeout(() => {
          this.selectedDate = currentSelectedDate;
        }, 0);
      })

      this.mapService.zoomLevel$.subscribe((zoomLevel) => {
        this.currentZoomLevel = zoomLevel;
        this.isLoggedIn = this.authService.isUserLoggedIn();
        this.isPrivileged = this.authService.isPrivileged();
        this.updateMaxSelectableDate();
      });

      this.generateVisibleMonths();
      this.onMonthSelect({ value: this.selectedMonth.value, year: this.selectedMonth.year });
    }

    updateMaxSelectableDate(): void {
      let futureMonthsAllowed = 0;
      if (this.currentZoomLevel >= GlobalVars.wfsSimplifiedMaxZoomAndSensors || this.isPrivileged) {
        futureMonthsAllowed = this.isLoggedIn && this.isPremium ? 3 : 1;
      }
      this.maxSelectableDate = new Date(this.currentYear, this.currentMonth + futureMonthsAllowed);
      this.cdRef.markForCheck();
    }

    generateVisibleMonths(): void {
      const months = [];
      const start = new Date(this.currentYear - 1, this.currentMonth);
      const end = new Date(this.currentYear, this.currentMonth + 3); 

      for (let d = start; d <= end; d.setMonth(d.getMonth() + 1)) {
        
        months.push({
          name: `${this.months[d.getMonth()].name} ${d.getFullYear()}`,
          value: d.getMonth(),
          year: d.getFullYear()
        });
      }

      this.visibleMonths = months;
    }

    // Nouvelle méthode pour générer une date avec le 1er jour du mois
    getFirstDayOfMonth(year: number, month: number): Date {
      return new Date(year, month, 1);
    }

    // Garde la logique actuelle pour obtenir une date valide (jour existant) dans le mois
    getValidDateForMonth(year: number, month: number): Date {
      const currentDay = this.exactSelectedDate.getDate();
      const lastDayOfMonth = new Date(year, month + 1, 0).getDate();
      const validDay = Math.min(currentDay, lastDayOfMonth);

      return new Date(year, month, validDay);
    }

    // Synchronisation avec le calendrier
    onCalendarSelect(event: any): void {
      const selectedDate = new Date(event);
      this.exactSelectedDate = selectedDate; 

      const selected = this.visibleMonths.find(month => month.value === selectedDate.getMonth() && month.year === selectedDate.getFullYear());

      if (selected) {
        this.selectedMonth = selected;
      } else {
        this.selectedMonth = {
          name: this.months[selectedDate.getMonth()].name,
          value: selectedDate.getMonth(),
          year: selectedDate.getFullYear()
        };
      }

      // Fixe selectedDate au 1er jour du mois pour le calendrier
      this.selectedDate = this.getFirstDayOfMonth(this.selectedMonth.year, this.selectedMonth.value);

      // Mise à jour du service avec la vraie date exacte
      this.sharedDateService.updateSelectedDate(this.exactSelectedDate);
      this.sidebarService.setSidebarStatus(false);
      this.cdRef.markForCheck();
    }

    // Gestion des boutons radio pour changer de mois
    onMonthSelect(event: any): void {
      const selected = this.visibleMonths.find(month => month.value === event.value && month.year === event.year);
      if (selected) {
        this.selectedMonth = selected;

        // Utilisation du premier jour du mois pour la sélection du calendrier
        this.selectedDate = this.getFirstDayOfMonth(event.year, event.value);

        // Garder la date exacte dans la nouvelle sélection
        this.exactSelectedDate = this.getValidDateForMonth(event.year, event.value);

        // Transmettre la date exacte au service
        this.sharedDateService.updateSelectedDate(this.exactSelectedDate);
        this.sidebarService.setSidebarStatus(false);
      }
      this.cdRef.markForCheck();
    }

    isFutureMonth(month: { value: number, year: number }): boolean {
      const now = new Date();
      const maxDate = this.maxSelectableDate;

      const isFuture = month.year > now.getFullYear() || 
                      (month.year === now.getFullYear() && month.value > now.getMonth());
      
      const isWithinLimit = month.year < maxDate.getFullYear() || 
                            (month.year === maxDate.getFullYear() && month.value <= maxDate.getMonth());

      return isFuture && !isWithinLimit;
    }

    isDecember(month: { value: number, year: number }): boolean {
      return month.value === 11;
    }

    isJanuary(month: { value: number, year: number }): boolean {
      return month.value === 0;
    }

    isInVisibleRange(month: { value: number, year: number }): boolean {
      return this.visibleMonths.some(visibleMonth => visibleMonth.value === month.value && visibleMonth.year === month.year);
    }

    markPermanentFutureMonths(month: { value: number, year: number }): boolean {
      const now = new Date();
      const maxDate = this.maxSelectableDate;
    
      const isAfterCurrentDate = month.year > now.getFullYear() || 
                                (month.year === now.getFullYear() && month.value > now.getMonth());
      
      return isAfterCurrentDate;
    }
    
    onTimelineItemClick(month: any): void {
      if (!this.isFutureMonth(month)) { // Vérifiez si le mois n'est pas désactivé
        this.selectedMonth = month;
        this.onMonthSelect({ value: month.value, year: month.year });
      }
    }

    isSelectedMonthInPast(): boolean {
      const now = new Date();
      return (
        this.selectedMonth.year < now.getFullYear() ||
        (this.selectedMonth.year === now.getFullYear() && this.selectedMonth.value < now.getMonth())
      );
    }
    
    isCurrentMonth(month: any): boolean {
      const now = new Date();
      return month.year === now.getFullYear() && month.value === now.getMonth();
    }
    
  }
